export const languageOptions = {
  en: "en",
  vi: "vi",
  th: "th",
};
